import { AlertTriangle, AlertCircle, Lock } from 'lucide-react'
import { Link } from 'react-router-dom'

import { Button } from '@/components/ui/button'
import { useSubscription } from '@/hooks/useSubscription'
import { SubscriptionStatus } from '@/types/enums'
import { formatDate } from '@/utils/date'

export function SubscriptionBanner() {
  const { status, lockedResources } = useSubscription()

  if (!status) return null

  if (status.status === SubscriptionStatus.EXPIRED) {
    return (
      <div className="bg-destructive-600 px-4 py-2 text-white">
        <div className="mx-auto flex max-w-7xl items-center justify-between">
          <div className="flex items-center gap-2">
            <AlertCircle className="h-5 w-5" />
            <span className="text-sm font-medium">
              Your subscription has expired. Please subscribe to continue using all features.
            </span>
          </div>
          <Button
            variant="secondary"
            size="sm"
            asChild
            className="bg-white text-destructive-600 hover:bg-neutral-100"
          >
            <Link to="/subscription">Subscribe Now</Link>
          </Button>
        </div>
      </div>
    )
  }

  if (status.cancelAtPeriodEnd) {
    return (
      <div className="bg-warning-500 px-4 py-2 text-white">
        <div className="mx-auto flex max-w-7xl items-center justify-between">
          <div className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5" />
            <span className="text-sm font-medium">
              Your subscription will cancel on {formatDate(status.currentPeriodEnd)}.
              <button className="ml-2 underline hover:no-underline">
                Undo cancellation
              </button>
            </span>
          </div>
        </div>
      </div>
    )
  }

  if (lockedResources && lockedResources.length > 0) {
    return (
      <div className="bg-warning-500 px-4 py-2 text-white">
        <div className="mx-auto flex max-w-7xl items-center justify-between">
          <div className="flex items-center gap-2">
            <Lock className="h-5 w-5" />
            <span className="text-sm font-medium">
              {lockedResources.length} resource{lockedResources.length > 1 ? 's' : ''} locked due to plan downgrade.{' '}
              <Link to="/subscription" className="underline hover:no-underline">
                Upgrade to unlock
              </Link>
            </span>
          </div>
        </div>
      </div>
    )
  }

  return null
}